import type { Sprite } from "./sprite";
import type { SpriteAnimation } from "./spriteAnimation";

export class ManagedAnimation {
	readonly spriteAnimation: SpriteAnimation;
	private currentFrame: number = 0;
	private expired: boolean = false;
	private totalElapsedTime: number = 0;
	private maxTime: number | null = null;
	private totalAnimationTime: number = 0;
	private timeStartForFrame: number[];
	private animationTimeSinceLoopStart: number = 0;

	constructor(animation: SpriteAnimation) {
		this.spriteAnimation = animation;
		this.timeStartForFrame = new Array(animation.frames.length);

		for (let frameIndex = 0; frameIndex < animation.frames.length; frameIndex++) {
			const frame = animation.frames[frameIndex];
			if (frameIndex === 0) {
				this.timeStartForFrame[frameIndex] = 0;
			} else {
				this.timeStartForFrame[frameIndex] = this.totalAnimationTime + 1;
			}
			this.totalAnimationTime += frame.interval;
		}
	}

	passTime(ms: number): boolean {
		this.totalElapsedTime += ms;
		if (this.maxTime !== null && this.totalElapsedTime >= this.maxTime) {
			this.expired = true;
			return true;
		}

		if (this.spriteAnimation.isSingleSprite()) return false;

		this.animationTimeSinceLoopStart += ms;

		let nextFrameTimeStart: number;
		if (this.currentFrame === this.timeStartForFrame.length - 1) {
			nextFrameTimeStart = this.totalAnimationTime;
		} else {
			nextFrameTimeStart = this.timeStartForFrame[this.currentFrame + 1];
		}

		if (this.animationTimeSinceLoopStart < nextFrameTimeStart) return false;

		if (this.animationTimeSinceLoopStart >= this.totalAnimationTime && !this.spriteAnimation.loop) {
			this.expired = true;
			this.currentFrame = this.timeStartForFrame.length - 1;
			return true;
		}

		this.animationTimeSinceLoopStart = this.animationTimeSinceLoopStart % this.totalAnimationTime;

		for (let frameIndex = 0; frameIndex < this.timeStartForFrame.length; frameIndex++) {
			if (this.animationTimeSinceLoopStart < this.timeStartForFrame[frameIndex]) {
				this.currentFrame = frameIndex - 1;
				return true;
			}
		}

		this.currentFrame = this.timeStartForFrame.length - 1;
		return true;
	}

	getCurrentSprite(): Sprite {
		return this.spriteAnimation.frames[this.currentFrame].sprite;
	}

	isExpired(): boolean {
		return this.expired;
	}

	getTotalElapsedTime(): number {
		return this.totalElapsedTime;
	}

	setMaxTime(ms: number | null): void {
		this.maxTime = ms;
	}
}
